import { CreateTaskCommentAttachmentFileQuery, TaskCommentAttachmentFileDownloadQuery, TaskCommentAttachmentFileDownloadResponse, TaskCommentAttachmentFileId } from '@/@types/taskCommentAttachmentFile';
import { TheoryApiAxiosBase } from '@/repository/base/axiosBase'
import { vxm } from '@/store';

export class TaskCommentAttachmentFilesRepository {
  private readonly axios = new TheoryApiAxiosBase();
  private readonly requestBasePath = 'v1/task-comment-attachment-files';
  /** 課題コメント添付ファイル登録 */
  async createTaskCommentAttachmentFile (
    param: FormData,
    query: CreateTaskCommentAttachmentFileQuery,
  ) {
    await this.axios.post(this.requestBasePath, param, {
      params: query,
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-role-param': `{"organizationId":${vxm.theoryApi.authStore.getCurrentOrganizationId},"projectId":${1}}`,
      },
    });
  }

  /** 課題コメント添付ファイルダウンロードURL取得 */
  async taskCommentAttachmentFileDownload(
    taskCommentAttachmentFileId: TaskCommentAttachmentFileId,
    query: TaskCommentAttachmentFileDownloadQuery,
  ) {
    const endPoint = `${this.requestBasePath}/${taskCommentAttachmentFileId.taskCommentAttachmentFileId}`;
    return (await this.axios.get<TaskCommentAttachmentFileDownloadResponse>(
      endPoint,
      {
        params: query,
      },
    )).data;
  }

  /**課題コメント削除 */
  async deleteTaskCommentAttachmentFile(taskCommentAttachmentFileId: number, projectId: number) {
    const endPoint = `${this.requestBasePath}/${taskCommentAttachmentFileId}`;
    const query = { 'project-id': projectId };
    await this.axios.delete(endPoint, { params: query });
  }
}
